/* src/app/components/user/UserContent/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { map, capitalize } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { CardContent, Typography } from '@material-ui/core';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = 'components';

const UserContent = ({ bio, education, hearAboutUs, locale }) => {
  const texts = loadTexts(TEXT_KEY, locale);
  return (
    <CardContent>
      {map(education, ({ university, year, type, major, minor, honors }, i) => (
        <div key={i}>
          <Typography>
            {`${university}, ${year}, ${capitalize(type)}`}
          </Typography>
          <Typography color="textSecondary" paragraph={!minor}>
            {`${major} ${honors ? texts.user.honours : ''}`}
          </Typography>
          {minor && (
            <Typography color="textSecondary" paragraph>
              {`${texts.user.minor}: ${minor}`}
            </Typography>
          )}
        </div>
      ))}
      <Typography paragraph>
        {bio}
      </Typography>
      <Typography variant="body2">
        {texts.user.hear}
      </Typography>
      <Typography>
        {hearAboutUs}
      </Typography>
    </CardContent>
  );
}

UserContent.propTypes = {
  bio: PropTypes.string,
  education: PropTypes.arrayOf(PropTypes.shape({
    university: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    major: PropTypes.string,
    minor: PropTypes.string,
    honors: PropTypes.bool,
    type: PropTypes.string,
  })),
  hearAboutUs: PropTypes.string,
};

UserContent.defaultProps = {
  bio: 'No bio set',
  education: [{
    university: 'University unknown',
    year: 'Year unknown',
    major: 'Major',
    minor: undefined,
  }],
  hearAboutUs: 'none',
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  connect(mapStateToProps, {})
)(UserContent);



// WEBPACK FOOTER //
// ./src/app/components/user/UserContent/index.js